<template>
  <Form class="ss" @submit="onSubmit" :validation-schema="schema">
    <slot></slot>
  </Form>
</template>
<script>
import { Form } from "vee-validate/dist/vee-validate.min.js";

export default {
  components: {
    Form,
  },
  mounted() {},
  props: {
    onSubmit: Function,
    schema: Object,
  },
};
</script>
